module.exports = __webpack_public_path__ + "img/frame-blue.5811bb11.svg";